export default __webpack_public_path__ + "static/media/reward-text.30b5cbb7.svg";